/**
 * dd-quiz — buscador de gafas PIXXIESX.
 *
 * Horizon es Liquid puro (sin build), así que esto es un web component vanilla
 * en el mismo idioma que el resto del tema (ver base.js), NO un island de React.
 *
 * MOTOR — por qué el uso filtra en vez de puntuar:
 * los datos reales del catálogo mandan. `recommended_uses` está en ~296 gafas y
 * es el único eje que separa de verdad el catálogo; `estilo_marco` (81%) y
 * `materials` (88%) están repartidos de forma casi idéntica entre todos los usos.
 * Si el uso solo sumara peso, responder "Aviador + Policarbonato" daría el MISMO
 * producto viniendo de "playa" o de "deporte" — el quiz parecería ramificado sin
 * serlo. Así que el uso es un FILTRO DURO sobre el universo de candidatos y las
 * preguntas puntúan dentro de él. Si el filtro deja el pool vacío (datos
 * incompletos), cae al catálogo completo en vez de dejar al comprador sin
 * respuesta.
 */
/* Iconos de línea en el idioma Phosphor "regular" (24×24, stroke currentColor,
   1.6, extremos redondeados) — el mismo lenguaje que el resto del tema. Se
   mapean por handle de track; un track sin icono dibujado cae al emoji del
   metaobjeto, así agregar uno en Admin nunca deja un hueco. */
const SVG = (d) =>
  `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${d}</svg>`;

const TRACK_ICONS = {
  // sol
  'playa-y-sol-intenso': SVG(
    '<circle cx="12" cy="12" r="4.2"/><path d="M12 2.6v2.2M12 19.2v2.2M4.4 4.4l1.6 1.6M18 18l1.6 1.6M2.6 12h2.2M19.2 12h2.2M4.4 19.6 6 18M18 6l1.6-1.6"/>',
  ),
  // monitor
  'pantalla-y-oficina': SVG(
    '<rect x="2.8" y="4.2" width="18.4" height="12.2" rx="1.8"/><path d="M9 20.2h6M12 16.4v3.8"/>',
  ),
  // persona en movimiento
  'deporte-y-outdoor': SVG(
    '<circle cx="14.6" cy="4.6" r="1.9"/><path d="M8 21l2.6-4.8 3-2.1-1.1-4.2-3.2 2.2-1.5 2.6"/><path d="M12.5 9.9 16 12l1.2 3.4M16.4 21l-1.9-4.3"/>',
  ),
  // destello
  'moda-y-estilo': SVG(
    '<path d="M12 3.4 13.9 9 19.5 11l-5.6 2L12 18.6 10.1 13 4.5 11 10.1 9 12 3.4Z"/><path d="M18.6 3.6l.7 1.9 1.9.7-1.9.7-.7 1.9-.7-1.9-1.9-.7 1.9-.7.7-1.9Z"/>',
  ),
  // ciudad
  'uso-diario': SVG(
    '<path d="M3.2 20.8V9.4l5.6-2.6v14M8.8 20.8V4.4l6.4 2.8v13.6M15.2 20.8v-9l5.6 2.4v6.6M2 20.8h20"/><path d="M5.6 12.4h.9M5.6 15.6h.9M11.2 10.4h1.1M11.2 13.6h1.1M11.2 16.8h1.1"/>',
  ),
  /* Test de lente rojo. El diseño del cliente usa emoji; nosotros mantenemos el
     idioma de línea del tema y tomamos solo el texto, que es lo que pidió. */
  // mando de consola
  'presell-gaming': SVG(
    '<path d="M7.4 7.6h9.2a4.4 4.4 0 0 1 4.3 3.5l.9 4.6a2.4 2.4 0 0 1-4.3 1.9l-1.4-1.9H8l-1.4 1.9a2.4 2.4 0 0 1-4.3-1.9l.9-4.6a4.4 4.4 0 0 1 4.3-3.5Z"/><path d="M7.6 11.6v2.4M6.4 12.8h2.4M15.8 11.9h.01M17.6 13.7h.01"/>',
  ),
  // portátil
  'presell-trabajo': SVG('<rect x="4" y="5" width="16" height="10.4" rx="1.6"/><path d="M2 18.6h20"/>'),
  // libros apilados
  'presell-estudio': SVG(
    '<path d="M4.4 5.2h5.2a2.4 2.4 0 0 1 2.4 2.4v11a1.8 1.8 0 0 0-1.8-1.8H4.4Z"/><path d="M19.6 5.2h-5.2a2.4 2.4 0 0 0-2.4 2.4v11a1.8 1.8 0 0 1 1.8-1.8h5.8Z"/>',
  ),
  // celular
  'presell-general': SVG('<rect x="6.6" y="2.6" width="10.8" height="18.8" rx="2.2"/><path d="M10.8 18.4h2.4"/>'),

  // horas frente a la pantalla — el mismo reloj, la manecilla marca la carga
  'rl-h-menos4': SVG('<circle cx="12" cy="12" r="8.4"/><path d="M12 7.4V12l3 1.8"/>'),
  'rl-h-4a8': SVG('<circle cx="12" cy="12" r="8.4"/><path d="M12 7.4V12l4.4.6"/>'),
  'rl-h-mas8': SVG('<circle cx="12" cy="12" r="8.4"/><path d="M12 7.4V12l2.4 3.6"/>'),

  // qué nota después de la pantalla
  'rl-s-ojos': SVG('<path d="M2.4 12S6 5.8 12 5.8 21.6 12 21.6 12 18 18.2 12 18.2 2.4 12 2.4 12Z"/><circle cx="12" cy="12" r="3"/>'),
  'rl-s-cabeza': SVG(
    '<path d="M15.6 21v-3.2l2-1.4-1.2-4.2a5.6 5.6 0 1 0-9.9 3.3v5.5"/><path d="M4.6 8.6l3 1.4M17.4 4.8l-1.9 2.3"/>',
  ),
  'rl-s-sueno': SVG('<path d="M20.4 14.6A8.6 8.6 0 0 1 9.4 3.6a8.6 8.6 0 1 0 11 11Z"/>'),
  'rl-s-nada': SVG('<circle cx="12" cy="12" r="8.6"/><path d="M8.4 12.2l2.6 2.6 4.6-5"/>'),

  // con qué frecuencia — barras que suben
  'rl-d-casi': SVG('<path d="M5 19v-4M12 19V9M19 19V5"/>'),
  'rl-d-aveces': SVG('<path d="M5 19v-4M12 19V9"/><path d="M19 19v-2" opacity=".35"/>'),
  'rl-d-rara': SVG('<path d="M5 19v-4"/><path d="M12 19v-3M19 19v-2" opacity=".35"/>'),
};

/* Indicativos. Lista corta a propósito: los países desde donde compra PIXXIESX,
   con Colombia primero. `len` es la longitud nacional (sin indicativo) y `groups`
   cómo se agrupa al escribir. Añadir un país es una línea. */
const DIAL_CODES = [
  { iso: 'CO', name: 'Colombia', dial: '+57', flag: '🇨🇴', len: 10, groups: [3, 3, 4], sample: '300 123 4567' },
  { iso: 'MX', name: 'México', dial: '+52', flag: '🇲🇽', len: 10, groups: [2, 4, 4], sample: '55 1234 5678' },
  { iso: 'US', name: 'Estados Unidos', dial: '+1', flag: '🇺🇸', len: 10, groups: [3, 3, 4], sample: '305 123 4567' },
  { iso: 'ES', name: 'España', dial: '+34', flag: '🇪🇸', len: 9, groups: [3, 3, 3], sample: '612 345 678' },
  { iso: 'AR', name: 'Argentina', dial: '+54', flag: '🇦🇷', len: 10, groups: [2, 4, 4], sample: '11 2345 6789' },
  { iso: 'CL', name: 'Chile', dial: '+56', flag: '🇨🇱', len: 9, groups: [1, 4, 4], sample: '9 1234 5678' },
  { iso: 'PE', name: 'Perú', dial: '+51', flag: '🇵🇪', len: 9, groups: [3, 3, 3], sample: '912 345 678' },
  { iso: 'EC', name: 'Ecuador', dial: '+593', flag: '🇪🇨', len: 9, groups: [2, 3, 4], sample: '99 123 4567' },
  { iso: 'VE', name: 'Venezuela', dial: '+58', flag: '🇻🇪', len: 10, groups: [3, 3, 4], sample: '412 123 4567' },
  { iso: 'PA', name: 'Panamá', dial: '+507', flag: '🇵🇦', len: 8, groups: [4, 4], sample: '6123 4567' },
  { iso: 'CR', name: 'Costa Rica', dial: '+506', flag: '🇨🇷', len: 8, groups: [4, 4], sample: '8312 3456' },
  { iso: 'BR', name: 'Brasil', dial: '+55', flag: '🇧🇷', len: 11, groups: [2, 5, 4], sample: '11 91234 5678' },
];

class DdQuiz extends HTMLElement {
  connectedCallback() {
    try {
      this.data = JSON.parse(this.querySelector('[data-dd-quiz-data]').textContent);
    } catch (_) {
      return; // sin datos la sección ya renderizó su estado vacío
    }
    if (!this.data?.tracks?.length) return;
    /* La respuesta del POST carga la página entera dentro del iframe oculto, y
       ahí dentro vive otra copia de esta sección: hay que callarla o arrancaría
       un segundo quiz invisible emitiendo sus propios eventos.
       🔴 Se reconoce por el NOMBRE del iframe, no por `window.top !== self`.
       Esa comprobación de "estoy en un iframe" mata también el quiz dentro del
       EDITOR DE TEMAS, que renderiza la tienda en un iframe: el merchant se
       queda mirando el respaldo sin JS, sin contador y con las opciones como
       enlaces a la colección. */
    if (/^ddq-sink-/.test(window.name || '')) return;

    // Si la sección trae portada de lanzamiento, el test arranca ahí; si no,
    // directo a la primera pregunta.
    const start = this.data.launch?.title ? 'intro' : 'hub';
    this.state = { phase: start, trackId: null, qIndex: 0, answers: {}, pending: null };
    this.root = this.querySelector('[data-dd-quiz-root]');
    /* Se captura ANTES del primer render: vive fuera de `this.root` para que
       `innerHTML` no lo destruya al cambiar de fase. */
    this.leadForm = this.querySelector('[data-dd-quiz-lead-form]');
    this.sink = this.querySelector('[data-dd-quiz-sink]');
    this.sink?.addEventListener('load', () => this.onSinkLoad());
    this.setupPhone();
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('submit', this.onSubmit.bind(this));
    // Al volver del formulario de contacto Shopify recarga con este parámetro.
    this.posted = new URLSearchParams(location.search).has('contact_posted');
    if (this.posted) this.state.phase = 'thanks';
    this.render();
    this.startCountdown();
  }

  /* Cuenta regresiva. El objetivo llega como fecha ISO desde los ajustes de la
     sección, así que el merchant la cambia sin tocar código. Si ya pasó, la
     portada se muestra sin contador en vez de con números negativos. */
  startCountdown() {
    const target = Date.parse(this.data.launch?.at || '');
    if (!target) return;
    clearInterval(this._cd);
    const tick = () => {
      const box = this.querySelector('[data-dd-countdown]');
      if (!box) return;
      let left = Math.floor((target - Date.now()) / 1000);
      if (left <= 0) {
        box.remove();
        clearInterval(this._cd);
        return;
      }
      const d = Math.floor(left / 86400);
      const h = Math.floor((left % 86400) / 3600);
      const m = Math.floor((left % 3600) / 60);
      const s = left % 60;
      const cells = box.querySelectorAll('[data-cd]');
      [d, h, m, s].forEach((v, i) => {
        if (cells[i]) cells[i].textContent = String(v).padStart(2, '0');
      });
    };
    tick();
    this._cd = setInterval(tick, 1000);
  }

  get track() {
    return this.data.tracks.find((t) => t.id === this.state.trackId) || null;
  }

  get questions() {
    return this.track?.questions || [];
  }

  get totalSteps() {
    // En el hub aún no hay track elegido: usar el más largo mantiene el total
    // estable desde el primer paso en vez de saltar de "1 de 1" a "1 de 4".
    const len = this.track
      ? this.questions.length
      : this.data.tracks.reduce((m, t) => Math.max(m, (t.questions || []).length), 0);
    return 1 + len;
  }

  get stepNumber() {
    if (this.state.phase === 'intro' || this.state.phase === 'hub') return 1;
    if (this.state.phase === 'question') return 2 + this.state.qIndex;
    return this.totalSteps;
  }

  onClick(e) {
    const el = e.target.closest('[data-act]');
    if (!el) return;
    const { act, value } = el.dataset;

    if (act === 'start') {
      this.state.phase = 'hub';
      this.render();
      return;
    }

    if (act === 'track') {
      this.state.trackId = value;
      this.state.qIndex = 0;
      this.state.answers = {};
      this.state.phase = this.questions.length ? 'question' : 'analyzing';
      this.render();
      if (this.state.phase === 'analyzing') this.runAnalyzing();
      return;
    }

    if (act === 'answer') {
      const q = this.questions[this.state.qIndex];
      if (!q) return;
      if (q.selectType === 'multi') {
        const cur = this.state.answers[q.id] || [];
        this.state.answers[q.id] = cur.includes(value) ? cur.filter((v) => v !== value) : [...cur, value];
        this.render();
      } else {
        this.state.answers[q.id] = value;
        this.state.pending = value;
        this.render();
        setTimeout(() => {
          this.state.pending = null;
          this.advance();
        }, this.reduced ? 0 : 260);
      }
      return;
    }

    if (act === 'continue') this.advance();
    if (act === 'back') this.back();
    if (act === 'restart') {
      this.state = {
        phase: this.data.launch?.title ? 'intro' : 'hub',
        trackId: null,
        qIndex: 0,
        answers: {},
        pending: null,
      };
      this.render();
    }
  }

  /* 🔴 El envío es NATIVO, a propósito, pero contra un iframe oculto.
     Interceptarlo con `fetch` NO funciona: la protección anti-bots de Shopify
     (hCaptcha) rellena el token `h-captcha-response` durante SU flujo de envío,
     así que un `preventDefault` nuestro lo deja vacío y el POST muere con 400
     "Missing CAPTCHA token" — el lead se pierde y el comprador ve un error.
     Con `target` apuntando al iframe, hCaptcha corre su flujo entero porque para
     él el envío es normal, y la respuesta cae dentro del iframe en vez de
     navegar: la confirmación sale en sitio y la página no se recarga. */
  onSubmit(e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('[data-dd-quiz-lead-form]')) return;

    // El número viaja compuesto en E.164; el campo visible es solo el nacional.
    this.syncPhone();

    const back = form.querySelector('[name="return_to"]');
    if (back) back.value = location.pathname + location.search;

    const error = form.querySelector('[data-dd-quiz-lead-error]');
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    const submit = form.querySelector('[type="submit"]');
    if (submit) {
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
    }

    /* hCaptcha puede tardar en resolver y reenviar el formulario, así que la
       confirmación la dispara la CARGA del iframe, no un temporizador. */
    this.awaitingSubmit = true;
  }

  /* La respuesta del POST aterriza aquí. Mismo origen, así que se puede leer y
     distinguir un envío bueno de uno que Shopify rechazó. */
  onSinkLoad() {
    if (!this.awaitingSubmit) return;
    this.awaitingSubmit = false;

    /* Solo se declara fallo con EVIDENCIA de fallo. La asimetría manda: un
       "listo" de más no cuesta nada —el POST salió y la validación del cliente
       ya filtró los datos malos—, mientras que un error falso hace que la
       persona reenvíe o se vaya, con su dato ya guardado. Documento en blanco,
       ilegible o inesperado cuenta como enviado. */
    let failed = false;
    try {
      const doc = this.sink.contentDocument;
      // El /challenge interactivo de hCaptcha y los errores de Shopify sí son
      // fallo: ahí hay que devolver el formulario en vez de mentir.
      failed =
        /captcha|challenge/i.test(doc?.title || '') || !!doc?.querySelector('.errors, .form__message--error');
    } catch (_) {
      failed = false;
    }

    const submit = this.leadForm?.querySelector('[type="submit"]');
    if (failed) {
      const error = this.leadForm?.querySelector('[data-dd-quiz-lead-error]');
      if (error) {
        error.textContent =
          this.data.confirmation?.submitError || 'No pudimos registrar tus datos. Revisa los campos e inténtalo otra vez.';
        error.hidden = false;
      }
      if (submit) {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
      return;
    }

    if (submit) submit.removeAttribute('aria-busy');
    this.state.phase = 'thanks';
    this.render();
    this.root.querySelector('[data-dd-quiz-thanks]')?.focus();
  }

  get reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  advance() {
    if (this.state.qIndex + 1 < this.questions.length) {
      this.state.qIndex += 1;
      this.render();
      return;
    }
    this.state.phase = 'analyzing';
    this.render();
    this.runAnalyzing();
  }

  back() {
    if (this.state.phase === 'question') {
      if (this.state.qIndex === 0) this.state.phase = 'hub';
      else this.state.qIndex -= 1;
      this.render();
    }
  }

  runAnalyzing() {
    const lines = this.data.analyzingLines?.length ? this.data.analyzingLines : ['Buscando tu par…'];
    let i = 0;
    const node = () => this.querySelector('[data-dd-quiz-analyzing-line]');
    if (this.reduced) {
      this.state.phase = 'result';
      this.render();
      return;
    }
    const iv = setInterval(() => {
      i = Math.min(lines.length - 1, i + 1);
      const n = node();
      if (n) n.textContent = lines[i];
    }, Math.max(420, 1700 / lines.length));
    setTimeout(() => {
      clearInterval(iv);
      this.state.phase = 'result';
      this.render();
    }, 1700);
  }

  /** El uso filtra; forma/material/precio puntúan dentro de ese universo. */
  resolve() {
    const all = this.data.products || [];
    const track = this.track;

    // Modo forzado (pre-venta): la landing ya vendió el producto, así que el
    // ganador no se discute. El ángulo elegido solo decide qué cierre lee el
    // comprador. Si el producto fijo no está en el catálogo servido
    // (despublicado, renombrado), cae al scoring normal en vez de dejar la
    // pantalla vacía.
    if (this.data.forcedProductHandle) {
      const pinned = all.find((p) => p.handle === this.data.forcedProductHandle);
      if (pinned) {
        return {
          winner: pinned,
          alts: [],
          forced: true,
          headline: track?.resultHeadline || null,
          body: track?.resultBody || null,
        };
      }
    }

    let pool = all;

    if (track?.useHandle) {
      const scoped = all.filter((p) => (p.uses || []).includes(track.useHandle));
      // Nunca dejar al comprador sin resultado por datos incompletos.
      if (scoped.length) pool = scoped;
    }

    const chosen = [];
    for (const q of this.questions) {
      const a = this.state.answers[q.id];
      const vals = Array.isArray(a) ? a : a ? [a] : [];
      for (const v of vals) {
        const opt = (q.options || []).find((o) => o.id === v);
        if (opt) chosen.push({ opt, weight: Number(q.weight || 1) || 1 });
      }
    }

    const scored = pool.map((p) => {
      let score = 0;
      for (const { opt, weight } of chosen) {
        if (!opt.matchField || !opt.matchValue) continue;
        if (opt.matchField === 'estilo' && p.estilo === opt.matchValue) score += weight;
        else if (opt.matchField === 'material' && (p.materials || []).includes(opt.matchValue)) score += weight;
        else if (opt.matchField === 'price') {
          const [lo, hi] = String(opt.matchValue).split('-').map(Number);
          const cents = Number(p.priceCents || 0);
          if (cents >= (lo || 0) && (!hi || cents < hi)) score += weight;
        }
      }
      return { p, score };
    });

    const featured = track?.featuredHandles || [];
    scored.sort((a, b) => {
      if (b.score !== a.score) return b.score - a.score;
      const fa = featured.indexOf(a.p.handle);
      const fb = featured.indexOf(b.p.handle);
      if (fa !== fb) return (fa < 0 ? 99 : fa) - (fb < 0 ? 99 : fb);
      return (a.p.priceCents || 0) - (b.p.priceCents || 0);
    });

    const winner = scored[0]?.p || null;
    const alts = scored.slice(1, 7).map((s) => s.p);
    return { winner, alts, poolSize: pool.length, scopedByUse: pool !== all };
  }

  // ---------- render ----------
  esc(s) {
    return String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  /* Barra continua, no segmentos: el diseño del cliente muestra una sola pista
     que se llena, con el conteo a la derecha. */
  progress() {
    const total = this.totalSteps;
    const cur = this.stepNumber;
    // La portada comparte el paso 1 con la primera pregunta, pero con la pista
    // vacía: todavía no has respondido nada.
    const pct = this.state.phase === 'intro' ? 0 : Math.round((cur / total) * 100);
    return `<div class="ddq__progress" role="progressbar" aria-valuemin="1" aria-valuemax="${total}" aria-valuenow="${cur}" aria-label="Pregunta ${cur} de ${total}"><span class="ddq__bar" style="width:${pct}%"></span></div><p class="ddq__step">Pregunta ${cur} de ${total}</p>`;
  }

  /**
   * Compatibilidad = suma de los `weight` de las respuestas. Es un indicador de
   * ENCAJE con el uso que la persona declara, no un diagnóstico: por eso el
   * texto de cada banda habla de rutina de pantalla y nunca de mejorar un
   * síntoma. Máximo posible 9 (3+3+3), mínimo 1 (1+0+1... "Nada en particular"
   * suma 0 justamente para poder caer en baja).
   */
  compatibility() {
    let score = 0;
    let max = 0;
    for (const q of this.questions || []) {
      const a = this.state.answers[q.id];
      const picked = Array.isArray(a) ? a : a ? [a] : [];
      const weights = (q.options || []).map((o) => Number(o.weight || 0));
      max += weights.length ? Math.max(...weights) : 0;
      for (const id of picked) {
        const o = (q.options || []).find((x) => x.id === id);
        if (o) score += Number(o.weight || 0);
      }
    }
    const pct = max ? score / max : 0;
    // Los cortes son ajustes de la sección: un cuestionario con otro número de
    // preguntas, u otros pesos, necesita otra severidad. Los valores por defecto
    // son los del test de lente rojo (72 / 42 sobre 9 puntos).
    const t = this.data.thresholds || {};
    const high = (Number(t.high) || 72) / 100;
    const mid = (Number(t.mid) || 42) / 100;
    const band = pct >= high ? 'alta' : pct >= mid ? 'media' : 'baja';
    return { score, max, pct, band };
  }

  /**
   * `multi` cambia la FORMA del indicador, no el texto: círculo = elige una,
   * cuadrado = puedes elegir varias. Es la convención universal de formularios,
   * así que el comprador ya la sabe leer sin que se lo expliquemos.
   * El rol ARIA acompaña (radio vs checkbox) para que lectores de pantalla
   * reciban la misma información que da la forma.
   */
  optionRow(o, chosen, act, multi = false) {
    const svg = TRACK_ICONS[o.id];
    const icon = svg
      ? `<span class="ddq__ico">${svg}</span>`
      : o.icon
        ? `<span class="ddq__ico" aria-hidden="true">${this.esc(o.icon)}</span>`
        : '';
    const cap = o.caption ? `<span class="ddq__opt-cap">${this.esc(o.caption)}</span>` : '';
    const role = multi ? 'checkbox' : 'radio';
    return `<button type="button" role="${role}" aria-checked="${chosen}" class="ddq__opt${chosen ? ' is-sel' : ''}" data-act="${act}" data-value="${this.esc(o.id)}">
      ${icon}
      <span class="ddq__opt-txt"><span class="ddq__opt-lab">${this.esc(o.label)}</span>${cap}</span>
      <span class="ddq__mark ddq__mark--${multi ? 'box' : 'dot'}" aria-hidden="true"></span>
    </button>`;
  }

  /* El formulario lo renderiza Liquid (`{% form 'contact' %}` firma el POST y
     Shopify se encarga del envío), así que aquí solo se clona al resultado y se
     le adjunta lo que respondió la persona. Sin JS el formulario no aparece,
     pero tampoco hay resultado que capturar. */
  mountLeadForm() {
    const slot = this.root.querySelector('[data-dd-quiz-leadslot]');
    /* Se MUEVE el formulario que ya existe en el DOM, no se clona. hCaptcha lo
       enganchó al cargar la página y le inyecta el token al interactuar; un clon
       nace sin ese enganche y el POST muere con 400 "Missing CAPTCHA token".
       Mover el nodo conserva listeners y campos inyectados. `render()` vacía
       `this.root`, así que el formulario queda suelto entre fases: por eso se
       guarda la referencia en vez de volver a buscarlo en el árbol. */
    if (!slot || !this.leadForm) return;
    this.leadForm.hidden = false;
    slot.appendChild(this.leadForm);
    const detail = slot.querySelector('[name="contact[body]"]');
    if (!detail) return;
    const c = this.compatibility();
    const lines = [`Compatibilidad: ${c.band} (${c.score}/${c.max})`];
    if (this.track?.label) lines.push(`Uso principal: ${this.track.label}`);
    for (const q of this.questions || []) {
      const a = this.state.answers[q.id];
      const picked = (Array.isArray(a) ? a : a ? [a] : [])
        .map((id) => (q.options || []).find((o) => o.id === id)?.label)
        .filter(Boolean);
      if (picked.length) lines.push(`${q.question} ${picked.join(', ')}`);
    }
    // La sección puede estar capturando para más de un lanzamiento, así que el
    // cierre lo pone el merchant en sus ajustes.
    lines.push(this.data.lead?.emailNote || 'Quiere que le avisen cuando esté disponible.');
    detail.value = lines.join('\n');
  }

  /* ---------- WhatsApp ----------
     El indicativo se elige, no se escribe. Un solo campo "con indicativo" hace
     que la gente lo ponga dos veces, o ninguna, y el número llega inservible.
     Aquí el país fija la longitud y el agrupado, el campo solo acepta dígitos,
     y lo que se envía es el E.164 compuesto. */
  setupPhone() {
    const box = this.querySelector('[data-dd-quiz-phone]');
    if (!box) return;
    this.phone = {
      box,
      select: box.querySelector('[data-ddq-country]'),
      input: box.querySelector('[data-ddq-phone-national]'),
      flag: box.querySelector('[data-ddq-flag]'),
      dial: box.querySelector('[data-ddq-dial]'),
      hidden: this.querySelector('[data-ddq-phone-value]'),
      hint: this.querySelector('[data-ddq-phone-hint]'),
    };
    const { select, input } = this.phone;
    if (!select || !input) return;

    select.innerHTML = DIAL_CODES.map(
      (c) => `<option value="${c.iso}">${c.flag} ${c.name} ${c.dial}</option>`,
    ).join('');
    select.value = 'CO';

    select.addEventListener('change', () => this.paintCountry());
    input.addEventListener('input', () => this.formatPhone());
    input.addEventListener('blur', () => this.formatPhone(true));
    this.paintCountry();
  }

  get country() {
    return DIAL_CODES.find((c) => c.iso === this.phone?.select?.value) || DIAL_CODES[0];
  }

  paintCountry() {
    const c = this.country;
    if (this.phone.flag) this.phone.flag.textContent = c.flag;
    if (this.phone.dial) this.phone.dial.textContent = c.dial;
    this.phone.input.placeholder = c.sample;
    this.phone.input.setAttribute('aria-label', `Número de WhatsApp en ${c.name}`);
    this.formatPhone();
  }

  /* Agrupa mientras se escribe. El cursor se deja al final a propósito: en un
     campo que solo acepta dígitos y se reescribe entero, devolverlo al medio
     salta de sitio en cuanto entra un separador. */
  formatPhone(final = false) {
    const c = this.country;
    const { input, hidden, hint } = this.phone;
    const digits = input.value.replace(/\D+/g, '').slice(0, c.len);

    let out = '';
    let i = 0;
    for (const g of c.groups) {
      if (i >= digits.length) break;
      out += (out ? ' ' : '') + digits.slice(i, i + g);
      i += g;
    }
    if (i < digits.length) out += (out ? ' ' : '') + digits.slice(i);
    input.value = out;

    const complete = digits.length === c.len;
    if (hidden) hidden.value = complete ? `${c.dial}${digits}` : '';

    /* Es opcional: vacío nunca es un error. Incompleto sí, porque un WhatsApp a
       medias es peor que no tenerlo — parece un dato bueno y no lo es. */
    const bad = digits.length > 0 && !complete;
    input.setCustomValidity(bad ? `El número de ${c.name} tiene ${c.len} dígitos.` : '');
    if (hint) {
      hint.hidden = !(bad && final);
      hint.textContent = bad ? `Faltan dígitos: en ${c.name} son ${c.len}.` : '';
    }
    this.phone.box.classList.toggle('is-bad', bad && final);
  }

  syncPhone() {
    if (this.phone?.input) this.formatPhone(true);
  }

  render() {
    const d = this.data;
    let body = '';

    if (this.state.phase === 'thanks') {
      const c = d.confirmation || {};
      body = `<section class="ddq__thanks" data-dd-quiz-thanks tabindex="-1" role="status">
        <div class="ddq__thanks-brand">
          ${c.eyebrow ? `<p class="ddq__thanks-eyebrow">${this.esc(c.eyebrow)}</p>` : ''}
          ${c.wordmark ? `<p class="ddq__thanks-wordmark">${this.esc(c.wordmark)}</p>` : ''}
        </div>
        <div class="ddq__thanks-card">
          <span class="ddq__thanks-check" aria-hidden="true">${SVG('<path d="m7.2 12.3 3.2 3.4 6.6-8.1" stroke-width="2.5"/>')}</span>
          <p class="ddq__thanks-title">${this.esc(c.title || '¡Listo! Ya estás dentro')}</p>
          ${c.body ? `<p class="ddq__thanks-body">${this.esc(c.body)}</p>` : ''}
          ${c.delivery ? `<p class="ddq__thanks-delivery">${this.esc(c.delivery)}</p>` : ''}
        </div>
      </section>`;
    } else if (this.state.phase === 'intro') {
      const L = d.launch || {};
      const cd = L.at
        ? `<div class="ddq__cd" data-dd-countdown>
            ${[['DÍAS'], ['HORAS'], ['MIN'], ['SEG']]
              .map(([lab]) => `<div class="ddq__cd-c"><span class="ddq__cd-n" data-cd>--</span><span class="ddq__cd-l">${lab}</span></div>`)
              .join('')}
          </div>${L.note ? `<p class="ddq__cd-note">${this.esc(L.note)}</p>` : ''}`
        : '';
      body = `${this.progress()}
        <div class="ddq__head ddq__head--left">
          <p class="ddq__q">${this.esc(L.title)}</p>
          ${L.body ? `<p class="ddq__sub">${this.esc(L.body)}</p>` : ''}
        </div>
        ${cd}
        <button type="button" class="ddq__cta ddq__cta--start" data-act="start">${this.esc(L.cta || 'Empezar el test')}</button>`;
    } else if (this.state.phase === 'hub') {
      body = `${this.progress()}
        <div class="ddq__head">
          <p class="ddq__q">${this.esc(d.hub?.question || '¿Qué buscas?')}</p>
          ${d.hub?.subtitle ? `<p class="ddq__sub">${this.esc(d.hub.subtitle)}</p>` : ''}
        </div>
        <div class="ddq__opts">${d.tracks.map((t) => this.optionRow({ id: t.id, label: t.label, caption: t.caption, icon: t.icon }, false, 'track', false)).join('')}</div>`;
    } else if (this.state.phase === 'question') {
      const q = this.questions[this.state.qIndex];
      const a = this.state.answers[q.id];
      const multi = q.selectType === 'multi';
      const sel = Array.isArray(a) ? a : a ? [a] : [];
      const n = sel.length;
      body = `${this.progress()}
        <div class="ddq__head">
          ${this.track?.label ? `<p class="ddq__eyebrow">${this.esc(this.track.label)}</p>` : ''}
          <p class="ddq__q">${this.esc(q.question)}</p>
          ${q.subtitle ? `<p class="ddq__sub">${this.esc(q.subtitle)}</p>` : ''}
          ${!q.subtitle && multi ? '<p class="ddq__sub">Puedes elegir varias.</p>' : ''}
        </div>
        <div class="ddq__opts" role="${multi ? 'group' : 'radiogroup'}">${(q.options || []).map((o) => this.optionRow(o, sel.includes(o.id) || this.state.pending === o.id, 'answer', multi)).join('')}</div>
        ${multi ? `<button type="button" class="ddq__cta" data-act="continue"${n ? '' : ' disabled'}>Continuar${n ? ` <span class="ddq__count">${n}</span>` : ''}</button>` : ''}
        <div class="ddq__foot"><button type="button" class="ddq__back" data-act="back">← Volver</button></div>`;
    } else if (this.state.phase === 'analyzing') {
      const first = (d.analyzingLines && d.analyzingLines[0]) || 'Buscando tu par…';
      body = `<div class="ddq__loading" role="status"><span class="ddq__spin" aria-hidden="true"></span><p data-dd-quiz-analyzing-line>${this.esc(first)}</p></div>`;
    } else if (d.leadMode) {
      /* Todavía no hay producto asociado: el resultado es la compatibilidad y
         un correo para avisar cuando exista. No inventamos un producto ni le
         enseñamos otro que no es el que estamos anunciando. */
      const c = this.compatibility();
      const band = (d.bands || {})[c.band] || {};
      body = `<div class="ddq__result" data-dd-track="component_view" data-dd-item="quiz-result" data-dd-value="compat-${c.band}">
        <span class="ddq__tag ddq__tag--${c.band}">${this.esc(band.label || '')}</span>
        <p class="ddq__q">${this.esc(band.headline || '')}</p>
        ${band.body ? `<p class="ddq__sub">${this.esc(band.body)}</p>` : ''}
        <div data-dd-quiz-leadslot></div>
        <button type="button" class="ddq__restart" data-act="restart">Repetir el test</button>
      </div>`;
    } else {
      const { winner, alts, forced, headline, body: angleBody } = this.resolve();
      if (!winner) {
        body = `<div class="ddq__result"><p class="ddq__q">Aún estamos ajustando el buscador</p><p class="ddq__sub">Escríbenos y te ayudamos a elegir.</p><button type="button" class="ddq__restart" data-act="restart">Repetir</button></div>`;
      } else {
        // En modo forzado el titular ES el angulo elegido; en el buscador
        // general el titular es el producto y debajo va el porque.
        // El cierre lo define el ANGULO elegido en la primera pregunta. Si el
        // merchant escribio una frase para ese angulo, esa manda; la plantilla
        // con el nombre del track queda solo como red de seguridad.
        const why = forced
          ? this.esc(angleBody || '')
          : this.track?.resultBody
            ? this.esc(this.track.resultBody)
            : this.track?.label
              ? `Por lo que nos dijiste sobre <strong>${this.esc(this.track.label.toLowerCase())}</strong>.`
              : '';
        const title = forced && headline ? this.esc(headline) : this.esc(winner.title);
        const chip = forced ? 'Para ti' : 'Tu resultado';
        body = `<div class="ddq__result" data-dd-track="component_view" data-dd-item="quiz-result" data-dd-value="${this.esc(winner.handle)}">
          <span class="ddq__chip">${chip}</span>
          <p class="ddq__q">${title}</p>
          ${why ? `<p class="ddq__sub">${why}</p>` : ''}
          <a class="ddq__card" href="${this.esc(winner.url)}" data-dd-action="view_product" data-dd-cta="quiz-result-product" data-dd-value="${this.esc(winner.handle)}">
            ${winner.image ? `<img src="${this.esc(winner.image)}" alt="${this.esc(winner.title)}" loading="lazy" width="480" height="480">` : ''}
            <span class="ddq__card-b"><span class="ddq__card-t">${this.esc(winner.title)}</span><span class="ddq__card-p">${this.esc(winner.priceFormatted || '')}</span></span>
          </a>
          <a class="ddq__cta ddq__cta--link" href="${this.esc(winner.url)}" data-dd-action="view_product" data-dd-cta="quiz-result-cta" data-dd-value="${this.esc(winner.handle)}">Ver este modelo</a>
          ${alts.length ? `<div class="ddq__alts"><p class="ddq__alts-t">También te pueden servir</p><div class="ddq__alts-g${alts.length > 3 ? ' is-rail' : ''}">${alts.map((p) => `<a class="ddq__alt" href="${this.esc(p.url)}" data-dd-action="view_product" data-dd-cta="quiz-result-alt" data-dd-value="${this.esc(p.handle)}">${p.image ? `<img src="${this.esc(p.image)}" alt="${this.esc(p.title)}" loading="lazy" width="200" height="200">` : ''}<span>${this.esc(p.title)}</span></a>`).join('')}</div></div>` : ''}
          <button type="button" class="ddq__restart" data-act="restart">Repetir búsqueda</button>
        </div>`;
      }
    }

    this.root.innerHTML = `<div class="ddq__panel" data-phase="${this.state.phase}">${body}</div>`;
    this.mountLeadForm();

    /* Avisar a la página que el quiz terminó. En una landing de pre-venta el
       producto no puede asomar por ningún lado mientras se responde: las
       secciones que hablan del producto se suscriben a esto y recién ahí
       aparecen. Se emite en `document` porque quien escucha es una SECCIÓN
       hermana, fuera de este árbol. */
    if (this.state.phase === 'result' && !this._announced) {
      this._announced = true;
      document.dispatchEvent(new CustomEvent('dd-quiz:complete'));
    }
  }
}

customElements.get('dd-quiz') || customElements.define('dd-quiz', DdQuiz);
